exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head {\n    padding: 16px 20px;\n    margin-bottom: 0;\n    background-color: #f7f7f9;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 22px;\n    cursor: pointer;\n}\n.poll-add-data {\n    border-top: 1px solid rgba(0,0,0,.125);\n    padding-top: 15px;\n    margin-top: 15px;\n    clear: both;\n}\n.content-btn-grp input {\n    width: calc(100% - 40px);\n    height: 40px;\n    border: 1px solid #ddd;\n    display: inline-block;\n    vertical-align: middle;\n}\n.poll-add-data .iconButton {\n    float: none;\n    display: inline-block;\n    vertical-align: middle;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /workspace/backend-server/src/app/layout/cards/cards.component.css
// module id = ../../../../../src/app/layout/cards/cards.component.css
// module chunks = main